import { useNavigate } from 'react-router-dom';

const Button = ({ 
  children, 
  to, 
  onClick, 
  variant = 'accent',
  className = '',
  disabled = false,
  type = 'button',
  size = 'medium',
  ...props 
}) => {
  const navigate = useNavigate();

  // Base styles that will always be applied
  const baseStyles = "font-semibold rounded-md transition-all duration-300";

  // Variant styles
  const variants = {
    primary: "bg-primary-dark text-secondary hover:bg-secondary hover:text-dim-dark drop-shadow-md",
    secondary: "bg-secondary text-white hover:bg-accent-light hover:text-secondary",
    accent: "bg-accent-light text-secondary px-6 py-2 hover:bg-secondary hover:text-primary-dark drop-shadow-md",
    outline: "px-3 py-1 text-dim-light rounded-md border-2 border-dim-dark hover:bg-accent-lighter hover:text-primary-dark",
    ghost: "text-secondary bg-primary-dark hover:bg-accent-hard drop-shadow-md hover:text-dim-dark",
  };

  // Size styles
  const sizes = {
    small: "px-4 py-1 text-sm",
    medium: "px-6 py-2",
    large: "px-8 py-3 text-lg"
  };

  // Disabled styles
  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer";

  // Combine all styles
  const buttonStyles = `${baseStyles} ${variants[variant]} ${sizes[size]} ${disabledStyles} ${className}`;

  const handleClick = (e) => {
    if (disabled) return;
    
    if (to) {
      navigate(to);
    }
    
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      type={type}
      className={buttonStyles}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;